import { render, staticRenderFns } from "./DetailsRequestReturnMaterials.vue?vue&type=template&id=b0c48d30"
import script from "./DetailsRequestReturnMaterials.vue?vue&type=script&lang=js"
export * from "./DetailsRequestReturnMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports